export default __webpack_public_path__ + "locales/pt-BR/Payments.json?hash=708ba6b6e0fc6f3f4bf2779493fb7b19";